<template>
  <v-container fluid>
    <v-layout row>
      <v-flex col xs12 sm12 md12 lg10 offset-lg1>
        <v-breadcrumbs
          :items="breadcrumbs"
          class="mb-4">
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="$route.params.i === undefined"
      row
    >
      <v-flex col xs12 sm12 md12 lg8 offset-lg2>
        <v-data-table
          :headers="personnelHeaders"
          :items="personnelInfo"
          item-key="name"
          disable-initial-sort
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="{ item, index }">
            <tr>
              <td class="text-xs-center px-0" style="width: fit-content;">{{ index + 1 }}</td>
              <td @click="personnelClick(index + 1)" class="personnel-click">{{ item.name }}</td>
              <td class="text-xs-center">{{ item.position }}</td>
              <td class="text-xs-center">{{ item.faculty }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-layout
      v-else
      row
    >
      <v-flex col xs12 sm12 md12 lg10 offset-lg1>
        <v-data-table
          :headers="personnelInfoHeaders"
          :items="[personnelSelected]"
          disable-initial-sort
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="{ item }">
            <tr>
              <td class="text-xs-center">{{ item.name }}</td>
              <td class="text-xs-center">{{ item.position }}</td>
              <td class="text-xs-center">{{ item.faculty }}</td>
              <td v-html="item.graduated.field.join('<br />')" style="width: 1%; white-space:nowrap;"></td>
              <td v-html="item.graduated.university.join('<br />')" style="width: 1%; white-space:nowrap;"></td>
              <td class="text-xs-center" style="width: 1%; white-space:nowrap;">{{ item.specialization }}</td>
            </tr>
          </template>
        </v-data-table>

        <!-- Research list -->
        <v-toolbar
          color="cyan"
          class="mt-5"
          dark
          tabs
        >
          <v-toolbar-title>ผลงานวิจัย</v-toolbar-title>

          <template v-slot:extension>
            <v-tabs
              v-model="researchTab"
              slider-color="cyan"
              dark
            >
              <v-tab
                v-for="year in Object.keys(personnelSelected.research)"
                :key="`research-${year}`"
                ripple
              >
                ปี {{ year }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-tabs-items v-model="researchTab">
          <v-tab-item
            v-for="year of Object.keys(personnelSelected.research)"
            :key="`research-${year}`"
          >
            <v-card>
              <v-card-text>
                <v-data-table
                  :headers="personnelResearchHeaders"
                  :items="personnelSelected.research[year]"
                  disable-initial-sort
                  hide-actions
                  no-data-text="ไม่มีงานวิจัยในปีนี้"
                  class="elevation-0"
                >
                  <template v-slot:items="{ item, index }">
                    <tr>
                      <td class="text-xs-center px-0" style="width: 1%; white-space:nowrap;">{{ index + 1 }}</td>
                      <td class="text-xs-left">{{ item.name }}</td>
                      <td class="text-xs-center">{{ item.role }}</td>
                      <td class="text-xs-center">{{ item.budget }}</td>
                      <td class="text-xs-center">{{ item.year }}</td>
                      <td class="text-xs-center">
                        <a
                          v-if="item.doc"
                          :href="item.doc"
                          target="_blank"
                        >
                          บทคัดย่อ
                        </a>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <!-- Publish list -->
        <v-toolbar
          color="lime"
          class="mt-5"
          dark
          tabs
        >
          <v-toolbar-title>การตีพิมพ์เผยแพร่</v-toolbar-title>

          <template v-slot:extension>
            <v-tabs
              v-model="publishTab"
              slider-color="lime"
              dark
            >
              <v-tab
                v-for="year in Object.keys(personnelSelected.publish)"
                :key="`publish-${year}`"
                ripple
              >
                ปี {{ year }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-tabs-items v-model="publishTab">
          <v-tab-item
            v-for="year of Object.keys(personnelSelected.publish)"
            :key="`publish-${year}`"
          >
            <v-card>
              <v-card-text>
                <v-data-table
                  :headers="personnelPublishHeaders"
                  :items="personnelSelected.publish[year]"
                  disable-initial-sort
                  hide-actions
                  no-data-text="ไม่มีการตีพิมพ์เผยแพร่ในปีนี้"
                  class="elevation-0"
                >
                  <template v-slot:items="{ item, index }">
                    <tr>
                      <td class="text-xs-center px-0" style="width: 1%; white-space:nowrap;">{{ index + 1 }}</td>
                      <td class="text-xs-left">{{ item.name }}</td>
                      <td class="text-xs-center">{{ item.year }}</td>
                      <td class="text-xs-center">
                        <a
                          v-if="item.link"
                          :href="item.link"
                          target="_blank"
                        >
                          เอกสาร
                        </a>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import personnel from '@/data/personnel'

export default {
  name: 'ResearchInfo',

  data () {
    return {
      researchTab: 0,
      publishTab: 0,
      personnelIndex: null,
      personnelHeaders: [
        {
          text: 'ลำดับ',
          align: 'center',
          // width: '60',
          class: 'px-0',
          sortable: false
        },
        {
          text: 'ชื่อ - นามสกุล',
          align: 'left',
          sortable: false
        },
        {
          text: 'ตำแหน่ง',
          align: 'center',
          sortable: false
        },
        {
          text: 'คณะ',
          align: 'center',
          sortable: false
        }
      ],
      personnelInfoHeaders: [
        {
          text: 'ชื่อ - นามสกุล',
          align: 'center',
          sortable: false
        },
        {
          text: 'ตำแหน่ง',
          align: 'center',
          sortable: false
        },
        {
          text: 'คณะ',
          align: 'center',
          sortable: false
        },
        {
          text: 'คุณวุฒิ/สาขาวิชา',
          align: 'center',
          sortable: false
        },
        {
          text: 'สถาบันที่สำเร็จการศึกษา',
          align: 'center',
          sortable: false
        },
        {
          text: 'ความเชี่ยวชาญ',
          align: 'center',
          sortable: false
        }
      ],
      personnelResearchHeaders: [
        {
          text: 'ที่',
          align: 'center',
          // width: '60',
          class: 'px-2',
          sortable: false
        },
        {
          text: 'ชื่องานวิจัย',
          align: 'center',
          sortable: false
        },
        {
          text: 'หัวหน้าโครงการวิจัย/ผู้ร่วมวิจัย',
          align: 'center',
          sortable: false
        },
        {
          text: 'งบประมาณ',
          align: 'center',
          sortable: false
        },
        {
          text: 'ปีงบประมาณ',
          align: 'center',
          sortable: false
        },
        {
          text: 'บทคัดย่อ',
          align: 'center',
          sortable: false
        }
      ],
      personnelPublishHeaders: [
        {
          text: 'ที่',
          align: 'center',
          // width: '60',
          class: 'px-2',
          sortable: false
        },
        {
          text: 'บทความวิจัย/บทความวิชาการ',
          align: 'center',
          sortable: false
        },
        {
          text: 'ปีที่เผยแพร่',
          align: 'center',
          sortable: false
        },
        {
          text: 'เอกสาร',
          align: 'center',
          sortable: false
        }
      ]
    }
  },

  created () {
    this.initData()
  },

  computed: {
    breadcrumbs () {
      let bc = []
      if (this.$route.params.i === undefined) {
        bc.push(...[
          {
            text: 'หน้าแรก',
            exact: true,
            to: { path: '/info' }
          },
          {
            text: 'ฐานข้อมูลงานวิจัยและนวัตกรรมของอาจารย์',
            to: { path: '/info/personnel' }
          }
        ])
      } else {
        bc.push(...[
          {
            text: 'หน้าแรก',
            exact: true,
            to: { path: '/info' }
          },
          {
            text: 'ฐานข้อมูลงานวิจัยและนวัตกรรมของอาจารย์',
            exact: true,
            to: { path: '../personnel' } // { name: 'PersonnelInfo', params: {} }
          },
          {
            text: this.$route.params.name.replace('-', ' '),
            disabled: true,
            href: ''
          }
        ])
      }

      return bc
    },

    personnelInfo () {
      return personnel.data.person
    },

    personnelSelected () {
      return personnel.data.person[this.personnelIndex - 1]
    }
  },

  watch: {
    '$route' (to, from) {
      this.personnelIndex = to.params.i || null
    }
  },

  methods: {
    initData () {
      this.personnelIndex = this.$route.params.i || null
    },

    numberFormat (val, precise = 2) {
      return (val / 1).toFixed(precise).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    personnelClick (i) {
      if (i > 0) {
        this.personnelIndex = i
        this.personnelChange()
      }
    },

    personnelChange () {
      let routeParams = {
        i: this.personnelIndex,
        name: personnel.data.person[this.personnelIndex - 1]['name'].replace(' ', '-').replaceAll(' ', '')
      }

      this.$router.push({
        name: 'PersonnelInfoDetail',
        params: routeParams
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.personnel-click {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonnelInfo.vue